var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2501_15596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.51587H10.625V4.26587C10.625 2.54087 9.225 1.14087 7.5 1.14087C5.775 1.14087 4.375 2.54087 4.375 4.26587V5.51587H3.75C3.05937 5.51587 2.5 6.07524 2.5 6.76587V13.0159C2.5 13.7065 3.05937 14.2659 3.75 14.2659H11.25C11.9406 14.2659 12.5 13.7065 12.5 13.0159V6.76587C12.5 6.07524 11.9406 5.51587 11.25 5.51587ZM7.5 11.1409C6.80937 11.1409 6.25 10.5815 6.25 9.89087C6.25 9.20024 6.80937 8.64087 7.5 8.64087C8.19062 8.64087 8.75 9.20024 8.75 9.89087C8.75 10.5815 8.19062 11.1409 7.5 11.1409ZM9.4375 5.51587H5.5625V4.26587C5.5625 3.19712 6.43125 2.32837 7.5 2.32837C8.56875 2.32837 9.4375 3.19712 9.4375 4.26587V5.51587Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2501_15596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.515869)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock1);
export default __webpack_public_path__ + "static/media/lock1.b309a34d14dfe95f5dcb35677390308d.svg";
export { ForwardRef as ReactComponent };